import { I18N } from 'core';

export default {
  'zh-CN': {
    vanCalendar: {
      end: I18N.translate('Fleet_Resdesign_End_HlIj', '结束'),
      start: I18N.translate('Fleet_Resdesign_Start_SDWR', '开始'),
      title: I18N.translate('Fleet_Resdesign_Calendar_mFPf', ' 日历'),
      weekdays: [
        I18N.translate('Fleet_Resdesign_Sunday_jiVr', '周日'),
        I18N.translate('Fleet_Resdesign_Monday_bazB', '周一'),
        I18N.translate('Fleet_Resdesign_Tuesday_UAxw', '周二'),
        I18N.translate('Fleet_Resdesign_Wednesday_IHFc', '周三'),
        I18N.translate('Fleet_Resdesign_Thursday_JOxF', '周四'),
        I18N.translate('Fleet_Resdesign_Friday_GxZE', '周五'),
        I18N.translate('Fleet_Resdesign_Saturday_mzeO', '周六')],
      monthTitle: (year: number, month: number) => `${month}/${year}`,
    },
  },
};
